export default class E {
  constructor(t = !1, s = []) {
    (this.ss = t), (this.fe = s), (this.ss = t), (this.fe = s);
  }
  It(t) {
    (this.ss = this.ss && t.ss), this.fe.push(...t.fe);
  }
}
